import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_card, null, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("h3", null, _toDisplayString(_ctx.$t("register.title")), 1),
          _createVNode("p", null, _toDisplayString(this.$t("general.description")), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          onSubmit: _ctx.onSubmit,
          "status-icon": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              error: _ctx.errors.name,
              label: _ctx.$t('register.name.label')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _ctx.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["error", "label"]),
            _createVNode(_component_el_form_item, {
              error: _ctx.errors.email,
              label: _ctx.$t('login.email.label')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "email",
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.email = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["error", "label"]),
            _createVNode(_component_el_form_item, {
              error: _ctx.errors.password,
              label: _ctx.$t('login.password.label')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "password",
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.password = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["error", "label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _ctx.onSubmit,
                  type: "primary",
                  loading: _ctx.isSubmitting
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("register.button")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"]),
                _createVNode(_component_el_link, {
                  style: {"margin-left":"1rem"},
                  onClick: _withModifiers(_ctx.backToLogin, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("register.to_start")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ]),
      _: 1
    }),
    _hoisted_2,
    _createVNode(_component_el_link, {
      style: {"margin-left":"1rem"},
      href: "https://kopiraittila.fi/toinenaste/tietosuojaseloste/",
      target: "_new"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("general.privacypolicy")), 1)
      ]),
      _: 1
    })
  ], 64))
}